import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import "../../css/templateForm.scss";

export default function ApprovedTemplateModal(props) {
  const { closeApprovedTemplateModal, submitMLR } = props;

  return (
    <>
      <div className="deleteConfirmation-main">
        <span className="approvedConfirmation">
          The asset is MLR Approved.{" "}
        </span>
        <span className="approvedConfirmation2 approvedConfirmation">
          Resubmission will lead to new MLR cycle !
        </span>
      </div>

      <div className="approvedTemp d-flex ">
        <div className="cancelAp">
          <Button
            type="button"
            onClick={() => closeApprovedTemplateModal()}
            className="cancel-approvedMlr "
          >
            CANCEL
          </Button>
        </div>
        <div className="proceedAp">
          <Button
            type="button"
            onClick={submitMLR}
            className="proceed-approvedmlr"
          >
            PROCEED
          </Button>
        </div>
      </div>
    </>
  );
}
